<template>
  <div class="row collapsible-body">
    <h4 class="col s12 light">Récapitulatif</h4>

    <form class="col s12" autocomplete="off">
      <h5 class="col s12 light">Trajet</h5>

      <p>
        <span>Vous allez voyager de <strong>{{ departure_name }}</strong> à
          <strong>{{ destination_name }}</strong> le <strong>{{ date }}</strong>{{ hour? " à " + hour : "" }}.</span>

        <span v-if="datereturn">
          Votre trajet retour est prévu le <strong>{{ datereturn }}</strong>{{
  hourreturn? " à " + hourreturn : ""
          }}.</span>

        <span v-else> Pas de retour prévu.</span>
      </p>

      <h5 class="col s12 light">Coordonnées</h5>

      <p>
        Téléphone : {{ phone }}<br />
        Mail : {{ mail }}
      </p>

      <h5 class="col s12 light">Passager{{ place > 1 ? "s" : "" }}</h5>

      <div :key="id" v-for="(num, id) in place">
        <p>
          {{ passengers.firstname[id] }} {{ passengers.lastname[id] }},
          <strong>né le {{ passengers.birthday[id] }}</strong>, de nationalité {{ passengers.nationality[id] }}, numéro
          de
          passeport {{ passengers.passport[id] }}.
        </p>

        <ul v-if="passengers.prices[id]" class="showprices collapsible">
          <li>
            <div class="collapsible-header right-align">
              tarif : {{ format(passengers.prices[id].amount) }}
            </div>
            <div class="collapsible-body frais">
              <p v-if="
                Number(passengers.prices[id].fraisAnnulationApresDepart) !== 0
              ">
                frais d'annulation après départ :
                {{ format(passengers.prices[id].fraisAnnulationApresDepart) }}
              </p>
              <p v-if="
                Number(passengers.prices[id].fraisAnnulationAvantDepart) !== 0
              ">
                frais d'annulation avant départ :
                {{ format(passengers.prices[id].fraisAnnulationAvantDepart) }}
              </p>
              <p v-if="
                Number(passengers.prices[id].fraisModificationApresDepart) !==
                0
              ">
                frais de modification après départ :
                {{ format(passengers.prices[id].fraisModificationApresDepart) }}
              </p>
              <p v-if="
                Number(passengers.prices[id].fraisModificationAvantDepart) !==
                0
              ">
                frais de modification avant départ :
                {{ format(passengers.prices[id].fraisModificationAvantDepart) }}
              </p>
              <p v-if="Number(passengers.prices[id].franchiseMainAller) !== 0">
                franchise main aller :
                {{ format(passengers.prices[id].franchiseMainAller) }}
              </p>
              <p v-if="Number(passengers.prices[id].franchiseMainRetour) !== 0">
                franchise main retour :
                {{ format(passengers.prices[id].franchiseMainRetour) }}
              </p>
              <p v-if="Number(passengers.prices[id].franchiseSouteAller) !== 0">
                franchise soute aller :
                {{ format(passengers.prices[id].franchiseSouteAller) }}
              </p>
              <p v-if="Number(passengers.prices[id].franchiseSouteRetour) !== 0">
                franchise soute retour :
                {{ format(passengers.prices[id].franchiseSouteRetour) }}
              </p>
            </div>
          </li>
        </ul>
      </div>

      <h5 class="col s12 light">
        Montant total à régler : {{ format(total) }}
      </h5>

      <div class="input-field col s12" style="height: 95px;">
        <label for="cbcgu">
          <input type="checkbox" id="cbcgu" class="filled-in" v-model="cgu" />
          <span class="left-align">En confirmant votre commande, vous reconnaissez avoir pris connaissance des
            <a href="/conditions-generales-de-vente-et-de-transport/" target="_blank">
            conditions générales de vente et transport</a>, et les accepter en totalité.</span>
        </label>
      </div>

      <div class="input-field col s12 right-align">
        <a id="cancelSummary" class="action-retour">corriger</a>
        <button id="validSummary" class="waves-effect waves-light btn">
          Payer maintenant
        </button>
      </div>
    </form>
  </div>
</template>


<script>
import axios from "axios";
import API from "../api.js";
import M from "materialize-css";
import jQuery from "jquery";
window.jQuery = jQuery;
require("jquery.redirect/jquery.redirect.js");

// import qs from "qs";

export default {
  props: {},
  data() {
    return {
      departure: null,
      destination: null,
      departure_name: null,
      destination_name: null,
      place: 1,
      date: null,
      datereturn: null,
      codedate: null,
      codedatereturn: null,
      phone: null,
      mail: null,
      passengers: {
        firstname: ["orel"],
        lastname: ["orel"],
        birthday: ["orel"],
        nationality: ["orel"],
        paysnaissance: ["orel"],
        villenaissance: ["orel"],
        passport: ["orel"],
        prices: [{ amount: 12 }],
      },
      cities: [],
      hour: null,
      hourreturn: null,
      total: 0,
      cgu: true
    };
  },
  mounted() {

    // Force value change to disable button with watcher
    this.cgu = false;

    axios.get(API.cities).then((resp) => {
      this.cities = resp.data.cities;
    });

    this.$root.$on("emit-travelers", async (data) => {
      let city;
      for (const [key, value] of Object.entries(data)) {
        switch (key) {
          case "departure":
          case "destination":
            city = this.$data.cities.find((c) => c.code == value);
            this[key + "_name"] = "name" in city ? city.name : value;
            this[key] = value;
            break;
          default:
            this[key] = value;
        }
      }

      this.total = 0;

      // update tarifs

      this.passengers.prices = Array(this.place);

      this.passengers.birthday.slice(0, this.place).map((val, id) => {
        axios
          .get(API.prices, {
            params: {
              destination: this.destination,
              departure: this.departure,
              date_leave: this.date.split("/").reverse().join("-"),
              date_return: this.datereturn ? this.datereturn.split("/").reverse().join("-") : '',
              birthday: val.split("/").reverse().join("-"),
            },
          })
          .then((p) => {
            // this.passengers.prices.push(p.data.prices[0]);
            this.passengers.prices[id] = p.data.prices[0];
            this.total += p.data.prices.reduce(
              (acc, val) => acc + Number(val.amount),
              0
            );
            this.$forceUpdate();
          });
      });
    });

    jQuery("#validSummary").on(
      "click",
      function (e) {
        e.preventDefault();
        this.save(); // données précédemments validées dans Travelers
      }.bind(this)
    );

    jQuery("#cancelSummary").on("click", function () {
      var instance = M.Collapsible.getInstance(jQuery(".collapsible"));
      instance.open(1);
      jQuery("html, body").animate({ scrollTop: 0 }, "slow");
    });
  },
  updated() {
    // manual Materialize Dropdown activation
    let elems = document.querySelectorAll(".showprices");
    M.Collapsible.init(elems, {});
  },
  watch: {
    cgu: function (val) {
      let valideBtn = document.querySelector("#validSummary");

      if (val === true) {
        valideBtn.classList.remove("disabled");
      } else {
        valideBtn.classList.add("disabled");
      }
    }
  },
  methods: {
    format(num) {
      return Number(num).toFixed(2) + "€";
    },
    save() {
      console.log("saving reservation !");
      console.log(this.$data);

      // ne garder que les champs nécessaires

      const siren = {
        codedate: this.$data.codedate,
        codedatereturn: this.$data.codedatereturn,
        mail: this.$data.mail,
        phone: this.$data.phone,
        passengers: JSON.stringify(this.$data.passengers)
      }

      console.log(siren);

      // https://github.com/mgalante/jquery.redirect
      jQuery.redirect(API.save, siren, "POST");


      /*

      axios
        .post(API.save, qs.stringify(siren))
        .then((res) => {
          console.log(res);

          // if (
          //   !res.data.payment ||
          //   !res.data.status ||
          //   res.data.status != "ok"
          // ) {
          //   alert(
          //     "Désolé, notre serveur a rencontré une petite erreur... " +
          //       "merci de réessayer un peu plus tard :)"
          //   );
          //   this.$router.push("/");
          // }

          for (let prop in res.data.payment) {
            let val = res.data.payment[prop];
            if (!val) continue;

            if (prop == "url") {
              document.querySelector("#banque").setAttribute("action", val);
            }

            if (prop.startsWith("pbx")) {
              document.querySelector(
                "#banque input[name=" + prop.toUpperCase() + "]"
              ).value = val;
            }
          }

          document.querySelector("#banque").submit();
        })
        .catch((err) => {
          console.log(err);
          alert(
            "Désolé, notre serveur a rencontré une petite erreur... " +
            "merci de réessayer un peu plus tard :)"
          );
          // this.$router.push('/');
        });

        */
    },
  },
};
</script>


<style scoped>
.collapsible-body {
  background-color: white;
  margin-top: 105px;
  margin-bottom: 0;
  color: rgba(0, 0, 0, 0.87);
}

h4::first-letter {
  text-transform: uppercase;
}

.frais {
  text-align: right;
  font-style: italic;
  color: grey;
  margin-top: 0 !important;
  padding: 10px !important;
}

.frais p {
  margin: 0;
}
</style>